(() => {
  const discountPhrases = ['Get 10% OFF', 'Get 35% OFF', 'GET 10% OFF', 'GET 35% OFF'];
  const frameTerms = ['chizy', 'cwillsendwill', 'nova-multi-currency', 'nova-currency'];

  const isProtected = (node) => !!node?.closest?.('header,.header,.pmx-h,.pmx,.footer,#MainContent .price,.price,[class*="live-chat"],[class*="chat-widget"]');

  const hideFloatingAncestor = (node) => {
    if (!node || isProtected(node)) return;
    let current = node;
    for (let depth = 0; current && depth < 10; depth += 1, current = current.parentElement) {
      if (isProtected(current)) return;
      const style = window.getComputedStyle(current);
      const rect = current.getBoundingClientRect();
      const compact = rect.width > 0 && rect.width < 360 && rect.height > 0 && rect.height < 760;
      if (compact && (style.position === 'fixed' || style.position === 'sticky')) {
        current.style.setProperty('display', 'none', 'important');
        current.setAttribute('aria-hidden', 'true');
        return;
      }
    }
  };

  const cleanDiscounts = () => {
    document.querySelectorAll('button,a,span,div,[role="button"]').forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 90) return;
      if (discountPhrases.some((phrase) => text.includes(phrase))) hideFloatingAncestor(node);
    });
  };

  const cleanCurrencyFloat = () => {
    document.querySelectorAll('button,a,span,div,[role="button"]').forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 28) return;
      if (/^(?:🇿🇦\s*)?ZAR(?:\s*R)?(?:\s*[⌄▾▼])?$/.test(text)) hideFloatingAncestor(node);
    });
    document.querySelectorAll('iframe').forEach((frame) => {
      const src = (frame.getAttribute('src') || '').toLowerCase();
      if (frameTerms.some((term) => src.includes(term))) hideFloatingAncestor(frame);
    });
  };

  const clean = () => { cleanDiscounts(); cleanCurrencyFloat(); };
  const run = () => window.requestAnimationFrame(clean);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  [250,600,1200,2500,5000,9000].forEach((delay) => window.setTimeout(clean, delay));

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => { queued = false; clean(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
})();
